import { formatDuration } from '@/core/time';
import dayjs, { Dayjs } from 'dayjs';
import { FunctionComponent, useEffect, useState } from 'react';

export const Duration: FunctionComponent<{ startedAt: Date; completedAt?: Date | null }> = ({
  startedAt,
  completedAt,
}) => {
  const [completion, setCompletion] = useState<Date | Dayjs>(completedAt || dayjs());

  useEffect(() => {
    if (completedAt) return;
    const interval = setInterval(() => {
      setCompletion(dayjs());
    }, 1000);
    return () => clearInterval(interval);
  }, [completedAt]);

  const duration = Math.ceil(dayjs(completion).diff(dayjs(startedAt), 'second'));
  return <span className='text-xs font-mono font-medium'>{formatDuration(duration)}</span>;
};
